import { inject, Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { take, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectNonConsumers } from '@app/resources/ngrx/selectors';
import { NonConsumerActions } from '@app/resources/ngrx/actions';

@Injectable()
export class NonMemberModuleRouteResolver implements Resolve<any> {
  private readonly store = inject(Store);

  resolve(route: ActivatedRouteSnapshot) {
    return this.store.select(selectNonConsumers).pipe(
      take(1),
      tap((consumers) => {
        this.store.dispatch(NonConsumerActions.loadNonConsumers());
      })
    );
  }
}
